import {
    API_URL_BASE,
    HOST,
    MAGENTO_URL,
    PROD_HOST,
} from '@perpay-web/constants/urls';

/* CONFIGURATIONS */
const HELP_SUBDOMAIN = 'help';
const TRACKING_SUBDOMAIN = 'tracking';
const BLOG_SUBDOMAIN = 'blog';

export const APP_HOST = `app.${HOST}`;

export const TRACKING_HOST = `${TRACKING_SUBDOMAIN}.${PROD_HOST}`;
const HELP_HOST = `${HELP_SUBDOMAIN}.${PROD_HOST}`;

/* APP VERSION FILE */
export const APP_VERSION_FILE_URL = '/VERSION.json';

/* THIRD PARTY SCRIPTS */
export const PINWHEEL_SCRIPT = 'https://cdn.getpinwheel.com/pinwheel-v3.0.js';
export const RETURNGO_SCRIPT =
    'https://static.returngo.ai/master.returngo.ai/returngo.min.js';
export const DECAGON_LOADER_SCRIPT = 'https://decagon.ai/loaders/perpay.js';

export const HOME_PAGE_URL = `https://${HOST}/`;
export const PAY_LOAN_URL = `https://${HOST}/order/:uuid/payment/`;
export const TRACKING_ORDER_URL = `https://${TRACKING_HOST}/`;
export const LEARN_DENIED_URL = `https://${HELP_HOST}/en/articles/450236-marketplace-order-approval-process`;
export const HOLIDAY_EARLY_SHIPPING_URL = `https://${HOST}/order/:uuid/followup/`;
export const CARD_STATEMENTS_APP_URL = `https://${HOST}/card/statement/:uuid`;

/* JWT ENABLED URLS */
export const JWT_MAGENTO_URL = `${MAGENTO_URL}jwt`;
export const JWT_ENABLED_URLS = [JWT_MAGENTO_URL];

/* AUTH */
export const RESET_PASSWORD_ENDPOINT = `${API_URL_BASE}/auth/password-reset/`;
export const SEND_MFA_CODE_ENDPOINT = `${API_URL_BASE}/auth-mfa/send-code/`;
export const SET_PASSWORD_ENDPOINT = `${API_URL_BASE}/auth/password`;
export const VALIDATE_MFA_CODE_ENDPOINT = `${API_URL_BASE}/auth-mfa/validate-code/`;

/* PAYCHEX */
export const PAYCHEX_SSO_URL_ENDPOINT = `${API_URL_BASE}/partner/paychex/login`;
export const PAYCHEX_LOGIN_ENDPOINT = `${API_URL_BASE}/partner/paychex/callback`;
export const PAYCHEX_EMPLOYMENT_INFO_ENDPOINT = `${API_URL_BASE}/partner/paychex/employment-info`;
export const PAYCHEX_CONFIRM_EMPLOYMENT_ENDPOINT = `${API_URL_BASE}/partner/paychex/employment-confirm`;
/* @knipignore until REview DD screen is integrated */
export const REVIEW_DIRECT_DEPOSIT_ENDPOINT = `${API_URL_BASE}/review-direct-deposit`;

/* MODEL BASED */
export const ADS_ENDPOINT = `${API_URL_BASE}/messages/`;
export const BANKS_ENDPOINT = `${API_URL_BASE}/bank-accounts/`;
export const BANK_VALIDATION_ENDPOINT = `${API_URL_BASE}/bank-accounts/validate/`;
export const BANK_VERIFICATION = `${API_URL_BASE}/bank-account-verification/`;
export const EXTERNAL_CARDS_ENDPOINT = `${API_URL_BASE}/cards/`;
export const ACCOUNT_DEACTIVATION_REASONS_ENDPOINT = `${API_URL_BASE}/account-deactivation-reasons/`;
export const EVENTS_ENDPOINT = `${API_URL_BASE}/events/`;
export const JOBS_ENDPOINT = `${API_URL_BASE}/jobs/`;
export const ORDERS_ENDPOINT = `${API_URL_BASE}/orders/`;
export const CHECKOUT_ENDPOINT = `${API_URL_BASE}/checkouts/:uuid/`;
export const CHECKOUT_REQUIREMENTS_ENDPOINT = `${API_URL_BASE}/checkouts/:uuid/requirements/`;
export const CHECKOUT_CONFIRM_ENDPOINT = `${API_URL_BASE}/checkouts/:uuid/confirm/`;
export const CHECKOUT_DECISION_ENDPOINT = `${API_URL_BASE}/checkouts/:uuid/decision/`;
// TODO stop usage and switch to newer account summary endpoints
export const ACCOUNT_SUMMARY_ENDPOINT = `${API_URL_BASE}/accounts/summary/`;
export const GENERAL_ACCOUNT_SUMMARY_ENDPOINT = `${API_URL_BASE}/account-summary/`;
export const CORE_SUMMARY_ENDPOINT = `${API_URL_BASE}/core-summary/`;
export const CARD_ACCOUNTS_ENDPOINT = `${API_URL_BASE}/card-accounts/`;
export const ORDER_CANCELLATION_REASONS_ENDPOINT = `${API_URL_BASE}/order-cancellation-reasons/`;
export const PAYROLL_INSTRUCTIONS_ENDPOINT = `${API_URL_BASE}/payroll-instructions/`;
export const PAYSTUBS_ENDPOINT = `${API_URL_BASE}/paystubs/`;
export const TRACKING_PAGEVIEW_ENDPOINT = `${API_URL_BASE}/tracking/pageview/`;
export const TRACKING_ITERABLE_TRACK_PUSH_OPEN_ENDPOINT = `${API_URL_BASE}/tracking/push/open`;
export const USERS_ENDPOINT = `${API_URL_BASE}/users/`;
export const USER_DEACTIVATION_ELIGIBILITY_ENDPOINT = `${API_URL_BASE}/users/me/deactivation-eligible/`;
export const USER_DEACTIVATION_ENDPOINT = `${API_URL_BASE}/users/me/deactivation/`;
export const USER_STATUS_ENDPOINT = `${API_URL_BASE}/users/me/status/`;
export const DEPOSITS_ENDPOINT = `${API_URL_BASE}/deposits/`;
export const SURVEYS_ENDPOINT = `${API_URL_BASE}/surveys/`;
export const PAYMENT_PLANS_ENDPOINT = `${API_URL_BASE}/payment_plans/`;
export const FEATURE_SWITCHES_ENDPOINT = `${API_URL_BASE}/feature-switch/`;
export const SURVEY_RESPONSES_ENDPOINT = `${API_URL_BASE}/surveys/pinwheel-exit-survey/survey_responses/`;
export const DEDUCTIONS_ENDPOINT = `${API_URL_BASE}/deductions/`;
export const REFERRAL_STATS_ENDPOINT = `${API_URL_BASE}/referrals/statistics/`;
export const REFERRAL_VALUES_ENDPOINT = `${API_URL_BASE}/referrals/values/`;
export const FEATURE_ENDPOINT = `${API_URL_BASE}/features/`;
export const FEATURE_ENROLLMENTS_ENDPOINT = `${API_URL_BASE}/feature_enrollments/`;
export const CREDIT_SCORE_HISTORY_ENDPOINT = `${API_URL_BASE}/credit-scores/`;
export const CREDIT_SCORES_SUMMARY_ENDPOINT = `${API_URL_BASE}/credit-scores/summary/`;
export const NOTIFICATIONS_ENDPOINT = `${API_URL_BASE}/notifications/`;
export const WITHDRAWAL_BALANCE_ENDPOINT = `${API_URL_BASE}/withdrawal-request-eligible/`;
export const WITHDRAWAL_REQUEST_ENDPOINT = `${API_URL_BASE}/withdrawal-requests/`;
export const CARD_ACCOUNT_APPLICATION_ENDPOINT = `${API_URL_BASE}/card-account-applications/`;
export const CARD_ACTIVATION_ENDPOINT = `${API_URL_BASE}/cards/:uuid/activate/`;
export const CARD_STATEMENTS_ENDPOINT = `${API_URL_BASE}/card-statements/`;
export const CARD_STATEMENTS_DOWNLOAD_ENDPOINT = `${API_URL_BASE}/card-statements/:uuid/download`;
export const PAYMENT_SETUP_SUMMARY_ENDPOINT = `${API_URL_BASE}/payment-setup/summary/`;
export const AUTO_PAY_SCHEDULE_ENDPOINT = `${API_URL_BASE}/auto-pay-schedule/`;
export const CARD_DOCUMENTS_ENDPOINT = `${API_URL_BASE}/card-documents/`;
export const AUTO_PAY_PAYMENTS_ENDPOINT = `${API_URL_BASE}/auto-pay-payments/`;
export const BORROWER_CREDIT_SUMMARY_ENDPOINT = `${API_URL_BASE}/borrower-credit-summary/`;
export const BORROWER_CREDITS_ENDPOINT = `${API_URL_BASE}/borrower-credits/`;
export const PAYMENTS_ENDPOINT = `${API_URL_BASE}/payments/`;
export const CARD_ACTIVITY_ENDPOINT = `${API_URL_BASE}/card-activities/`;
export const CREDIT_LIMITS_ENDPOINT = `${API_URL_BASE}/credit-limits/`;
export const TRANSACTION_DETAILS_ENDPOINT = `${API_URL_BASE}/transaction-details/`;
export const CARD_DASHBOARD_SUMMARY_ENDPOINT = `${API_URL_BASE}/dashboard/card-summary/`;
export const MARKETPLACE_DASHBOARD_SUMMARY_ENDPOINT = `${API_URL_BASE}/dashboard/marketplace-summary/`;
export const DASHBOARD_PLATFORM_SUMMARY_ENDPOINT = `${API_URL_BASE}/dashboard/platform-summary/`;
export const PERPAY_PLUS_DASHBOARD_SUMMARY_ENDPOINT = `${API_URL_BASE}/dashboard/perpay-plus-summary/`;
export const DIRECT_DEPOSIT_DASHBOARD_SUMMARY_ENDPOINT = `${API_URL_BASE}/dashboard/direct-deposit/`;
export const LEARN_MORE_ENDPOINT = `${API_URL_BASE}/dashboard/learn-more/`;
export const CARD_FREEZE_ENDPOINT = `${API_URL_BASE}/cards/:uuid/freeze`;
export const CARD_UNFREEZE_ENDPOINT = `${API_URL_BASE}/cards/:uuid/unfreeze`;
export const PAYCHEX_DEDUCTIONS_ENDPOINT = `${API_URL_BASE}/partner/paychex/deductions`;

/* FLOW BASED */
export const COMPANIES_ENDPOINT = `${API_URL_BASE}/company/typeahead/`;
export const COMPANIES_SELF_ONBOARDING_ENDPOINT = `${API_URL_BASE}/company/self-onboarding/typeahead/`;
export const SET_PHONE_ENDPOINT = `${API_URL_BASE}/phone-verification/`;
export const UPDATE_AND_VERIFY_PHONE_ENDPOINT = `${API_URL_BASE}/phone-change/`;
/* KNOWLEDGE BASE */
export const HOLIDAY_EARLY_SHIPPING_FAQ_URL = `https://${HELP_HOST}/common-perpay-terms/early-holiday-shipping`;
export const HELP_CENTER_HOME_URL = `https://${HELP_HOST}/en/`;
export const PAYSTUB_GUIDELINES_URL = `https://${HELP_HOST}/en/articles/4242465-perpay-s-paystub-guidelines`;

/* CARD KNOWLEDGE BASE */
export const AUTOMATIC_TRANSFERS_AGREEMENT_URL = `https://${HOST}/legal/automatic-transfer-agreement`;
export const CREDIT_CARDHOLDER_AGREEMENT_URL =
    'https://perpay.com/legal/credit-card-agreement';
export const REWARDS_PROGRAM_URL = `https://${HOST}/legal/credit-card-rewards-program`;
export const DIRECT_DEPOSIT_TERMS_URL = `https://${HOST}/legal/direct-deposit-terms`;
export const ELECTRONIC_CONSENT_POLICY_URL = `https://${HOST}/legal/electronic-consent`;
export const PRIVACY_POLICY_URL = `https://${HOST}/privacy`;
export const PRIVACY_NOTICE_URL = `https://${HOST}/legal/privacy-notice`;
export const USA_PATRIOT_ACT_NOTICE_URL = `https://${HOST}/legal/usa-patriot-act`;

/* PRIVACY & TERMS */
export const PERPAY_PRIVACY_POLICY_URL = `https://${HOST}/privacy`;
export const PERPAY_TERMS_AND_CONDITIONS_URL = `https://${HOST}/terms`;

/* BLOG */
export const BLOG_URL = `https://${BLOG_SUBDOMAIN}.${PROD_HOST}`;

/* FAQ LINKS */
export const FAQ_CLOSED_CARD_ACCOUNT =
    'https://help.perpay.com/en/articles/9116636-closing-your-perpay-credit-card';

/* Partner Hosted Onboarding Related Endpoints */
export const VERIFY_PARTNER_ONBOARDING_CODE_ENDPOINT = `${API_URL_BASE}/growth/partner-code/verification/`;
export const PARTNER_ONBOARDING_SUBMIT_CARD_APPLICATION_ENDPOINT = `${API_URL_BASE}/partner-onboarding/card-applications/`;
export const PARTNER_ONBOARDING_SUBMIT_MARKETPLACE_CARD_APPLICATION_ENDPOINT = `${API_URL_BASE}/partner-onboarding/marketplace-card-applications/`;

/* Card Migration Related Endpoints */
export const CARD_ACCOUNT_MIGRATE_ENDPOINT = `${API_URL_BASE}/card-accounts/:uuid/migrate`;
export const VIRTUAL_CARD_CREATE_ENDPOINT = `${API_URL_BASE}/cards/virtual/`;
export const APPLE_PAY_DIGITAL_WALLET_PROVISIONING_ENDPOINT = `${API_URL_BASE}/cards/virtual-provisioning/applepay/`;
export const ANDROID_PAY_DIGITAL_WALLET_PROVISIONING_ENDPOINT = `${API_URL_BASE}/cards/virtual-provisioning/androidpay/`;

/* Perpay+ Solo Related Endpoints */
export const PERPAY_PLUS_SOLO_SUBMIT_APPLICATION_ENDPOINT = `${API_URL_BASE}/perpay-plus/application/`;

/* Device */
export const DEVICES_ENDPOINT = `${API_URL_BASE}/devices`;

/* TrustPilot Iterable Feed Data */
export const TRUST_PILOT_ITERABLE_FEED_DATA = `${API_URL_BASE}/trustpilot-link/`;

/* Third Party Pages */
export const PERPAY_B_CORPORATION_URL =
    'https://www.bcorporation.net/en-us/find-a-b-corp/company/perpay-inc/';

/* Footprint */
export const FOOTPRINT_SESSION_ENDPOINT = `${API_URL_BASE}/footprint/session-token/`;
export const FOOTPRINT_TOKEN_VALIDATION_ENDPOINT = `${API_URL_BASE}/footprint/validation/`;

/* Incomplete PHO Application */
export const INCOMPLETE_PHO_APPLICATION_ENDPOINT = `${API_URL_BASE}/users/me/pho-application/`;

/* Signup Requirements */
export const SIGNUP_REQUIREMENTS_ENDPOINT = `${API_URL_BASE}/users/me/signup-requirements/`;

export const TERMS_AND_CONDITIONS =
    'https://perpay.com/legal/terms-and-conditions';
